import { render, staticRenderFns } from "./AdminChapterStates.vue?vue&type=template&id=4006ed5b&"
import script from "./AdminChapterStates.vue?vue&type=script&lang=js&"
export * from "./AdminChapterStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports